import React from "react";

export const B2BUpdateLead = ({ leadDetails }) => {

    const capitalizeFirstLetterOfEachWord = (str) => {

        if (!str) return "";

        return str
            .toLowerCase()
            .split(" ")
            .map(
                (word) =>
                    word.charAt(0).toUpperCase() +
                    word.slice(1)
            )
            .join(" ");

    };

    return (

        <div className="row">

            <div className="col-xl-12">

                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">

                    {/* HEADER */}
                    <div className="card-header bg-white border-bottom py-3">

                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">

                            <h5 className="mb-0 fw-bold text-dark">
                                Basic Information
                            </h5>

                            <span className="badge bg-primary rounded-pill px-3 py-2">
                                Lead ID : FS{leadDetails?.id || "--"}
                            </span>

                        </div>

                    </div>

                    {/* BODY */}
                    <div className="card-body p-4">

                        <div className="row g-4">

                            {/* PRIMARY CONTACT */}
                            <div className="col-md-4">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Primary Contact Name
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        {
                                            capitalizeFirstLetterOfEachWord(
                                                leadDetails?.primaryContactName
                                            )
                                        }

                                    </div>

                                </div>

                            </div>

                            {/* DESIGNATION */}
                            <div className="col-md-4">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Designation
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        {
                                            capitalizeFirstLetterOfEachWord(
                                                leadDetails?.primaryContactDesignation
                                            )
                                        }

                                    </div>

                                </div>

                            </div>

                            {/* MOBILE */}
                            <div className="col-md-4">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Mobile Number
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        +91{" "}
                                        {leadDetails?.mobileNumber || ""}

                                    </div>

                                </div>

                            </div>

                            {/* COMPANY */}
                            <div className="col-md-4">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Company Name
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        {
                                            capitalizeFirstLetterOfEachWord(
                                                leadDetails?.companyName
                                            )
                                        }

                                    </div>

                                </div>

                            </div>

                            {/* COMPANY ID */}
                            {leadDetails?.companyId && (

                                <div className="col-md-4">

                                    <div className="bg-light rounded-4 p-3 h-100">

                                        <small className="text-muted d-block mb-1">
                                            Company ID
                                        </small>

                                        <div className="fw-semibold text-dark">

                                            {leadDetails?.companyId}

                                        </div>

                                    </div>

                                </div>

                            )}

                            {/* EMAIL */}
                            <div className="col-md-4">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Email ID
                                    </small>

                                    <div className="fw-semibold text-dark text-break">

                                        {leadDetails?.emailId || ""}

                                    </div>

                                </div>

                            </div>

                            {/* BUSINESS CATEGORY */}
                            <div className="col-md-4">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Business Category
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        {leadDetails?.businessCategory || ""}

                                    </div>

                                </div>

                            </div>

                            {/* SHIPPING PARTNER */}
                            <div className="col-md-4">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Current Shipping Partner
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        {leadDetails?.currentShippingPartner || ""}

                                    </div>

                                </div>

                            </div>

                            {/* SHIPMENT POTENTIAL */}
                            <div className="col-md-4">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Shipment Potential
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        {leadDetails?.shipmentPotential || ""}

                                    </div>

                                </div>

                            </div>

                            {/* MIN EXPECTED */}
                            <div className="col-md-6">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Min Expected Shipment To Fship
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        {
                                            leadDetails?.minimumExpectedShipmentToFship || ""
                                        }

                                    </div>

                                </div>

                            </div>

                            {/* CLIENT PERSONA */}
                            <div className="col-md-6">

                                <div className="bg-light rounded-4 p-3 h-100">

                                    <small className="text-muted d-block mb-1">
                                        Client Persona
                                    </small>

                                    <div className="fw-semibold text-dark">

                                        {leadDetails?.clientPersona || ""}

                                    </div>

                                </div>

                            </div>

                            {/* UTM DETAILS */}
                            <div className="col-12">

                                <div
                                    className="rounded-4 p-4"
                                    style={{
                                        background: "#ffffff",
                                        border: "1px solid #edf0f5",
                                    }}
                                >

                                    <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">

                                        <div>

                                            <h5 className="fw-bold text-dark mb-1">
                                                UTM Details
                                            </h5>

                                            <small className="text-muted">
                                                Marketing tracking information
                                            </small>

                                        </div>

                                        <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill">
                                            Campaign Analytics
                                        </span>

                                    </div>

                                    <div className="row g-3">

                                        {[
                                            {
                                                label: "UTM Source",
                                                value: leadDetails?.utmSource,
                                                icon: "fe fe-globe",
                                            },

                                            {
                                                label: "UTM Medium",
                                                value: leadDetails?.utmMedium,
                                                icon: "fe fe-layers",
                                            },

                                            {
                                                label: "UTM Campaign",
                                                value: leadDetails?.utmCampaign,
                                                icon: "fe fe-target",
                                            },

                                            {
                                                label: "UTM Term",
                                                value: leadDetails?.utmTerm,
                                                icon: "fe fe-type",
                                            },

                                            {
                                                label: "UTM Content",
                                                value: leadDetails?.utmContent,
                                                icon: "fe fe-file-text",
                                            },

                                        ].map((item, index) => (

                                            <div
                                                className="col-xl-4 col-md-6"
                                                key={index}
                                            >

                                                <div
                                                    className="h-100 rounded-4 p-3"
                                                    style={{
                                                        background: "#f8fafc",
                                                        border: "1px solid #eef2f7",
                                                        transition: "0.3s",
                                                    }}
                                                >

                                                    <div className="d-flex align-items-start gap-3">

                                                        <div
                                                            className="d-flex align-items-center justify-content-center rounded-circle"
                                                            style={{
                                                                width: "42px",
                                                                height: "42px",
                                                                background:
                                                                    "rgba(13,110,253,0.1)",
                                                                color: "#0d6dfd",
                                                                fontSize: "16px",
                                                                flexShrink: 0,
                                                            }}
                                                        >

                                                            <i className={item.icon}></i>

                                                        </div>

                                                        <div className="w-100 overflow-hidden">

                                                            <small className="text-muted d-block mb-1">
                                                                {item.label}
                                                            </small>

                                                            <div
                                                                className="fw-semibold text-dark text-break"
                                                                style={{
                                                                    fontSize: "15px",
                                                                }}
                                                            >

                                                                {item.value || ""}

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        ))}

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

};